/**
 * HTML <input type="date"> only accepts YYYY-MM-DD. ISO strings with time
 * or invalid values show a blank field in many browsers.
 */
export function toDateInputValue(v) {
  if (v == null || v === "") {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  }
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return s;
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  }
  // Local calendar day — avoid UTC shift from toISOString() (e.g. IST evening → previous UTC day).
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Calendar-style label from YYYY-MM-DD, e.g. "05 May 2026" (no timezone shift). */
export function formatDateDisplayEnglish(isoYyyyMmDd) {
  if (isoYyyyMmDd == null || String(isoYyyyMmDd).trim() === "") return "";
  const s = String(isoYyyyMmDd).trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";
  const [y, m, d] = s.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
}

/** e.g. "May 2026" from yyyy-MM (no timezone shift). */
export function formatMonthDisplayEnglish(isoYyyyMm) {
  if (isoYyyyMm == null || String(isoYyyyMm).trim() === "") return "";
  const s = String(isoYyyyMm).trim();
  if (!/^\d{4}-\d{2}$/.test(s)) return "";
  const [y, m] = s.split("-").map(Number);
  if (m < 1 || m > 12) return "";
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${months[m - 1]} ${y}`;
}

/** e.g. 05-05-2026 for overview lines (DD-MM-YYYY). */
export function formatDateDdMmYyyy(v) {
  const s = toDateInputValue(v);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const [y, m, d] = s.split("-");
  return `${d}-${m}-${y}`;
}
